import { Transition } from "@unseenco/taxi";
import { gsap } from "gsap";

export default class TransitionDefault extends Transition {
    onLeave({ to, from, trigger, done }) {
        var tl = gsap.timeline({
            onComplete: () => {
                done();
            },
        });
        tl.to(from, { autoAlpha: 0, duration: 0.25 });
    }
    onEnter({ to, trigger, done, from }) {
        var tl = gsap.timeline({
            onComplete: () => {
                done();
            },
        });
        tl.fromTo(to, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.25 });
    }
}
